import { Routes } from '@angular/router';
import { ScopeGuard } from '../auth/services/scope.guard';
import { SCOPES } from 'src/app/app.constants';
import { POSGuard } from './services/pos.guard';
import { SALES_REGISTERS_ROUTES } from '../sales-registers/sales-registers.routes';

export const POS_ROUTES: Routes = [
  { path: 'cash-management', loadComponent: () => import('./components/cash-management/cash-management.component').then(m => m.CashManagementComponent), canActivate: [ScopeGuard], data: { scope: SCOPES.salesRegisters.cash } },
  { path: 'payment', loadComponent: () => import('./components/payment/payment.component').then(m => m.PaymentComponent), canDeactivate: [POSGuard] },
  { path: 'register', children: SALES_REGISTERS_ROUTES },
  { path: '', loadComponent: () => import('./components/cart/cart.component').then(m => m.CartComponent), canDeactivate: [POSGuard] }
];
